import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { SpacingToken, Tag } from "@livechat/design-system-react-components";

import { ITag } from "store/entities/tags";
import { withVar } from "themes/helpers";

interface ITagBadgesProps {
  tags: ITag[];
  onRemove?(tagId: string): void;
  children?: ReactNode;
}

export const TagBadges: FC<ITagBadgesProps> = ({ children, tags, onRemove }) => {
  const handleRemove = (tagId: string): void => {
    onRemove?.(tagId);
  };

  return (
    <Container>
      {children}
      {tags.map(tag => (
        <StyledTag
          key={tag.id}
          title={tag.name}
          data-testid={tag.name}
          dismissibleOnHover={!!onRemove}
          onRemove={onRemove ? (): void => handleRemove(tag.id) : undefined}
        >
          {tag.name}
        </StyledTag>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 ${withVar(SpacingToken.Spacing1)};
`;

const StyledTag = styled(Tag)`
  margin: ${withVar(SpacingToken.Spacing1)} 0;
`;
